<template>
  <div class="introduce-module">
    <div class="profile-banner">
      <div class="profile-title EC5 center">知行合一 &nbsp;&nbsp;链铸未来</div>
    </div>
    <div class="brief-content-text-wrapper">
      <div class="w1200">
        <div class="brief-content-box">
          <div class="brief-content-text">
            <h1 class="brief-content-text__title mb24">公司简介</h1>
            <div class="brief-content-text__desc">
              <p class="T6 mb16">
                厦门知链科技有限公司是AI大数据、区块链技术及解决方案提供商，致力于为政府及企业客户加速实现数字化转型。公司成立于2018年，总部位于厦门，公司核心团队均来自国内外一流高校。
              </p>
            </div>
            <img
              v-if="$store.state.sceneClassName !== 'app'"
              src="http://wechatapppro-1252524126.file.myqcloud.com/appAKLWLitn7978/image/kggpxjal03onq4nbaqev.png"
              alt=""
            />
          </div>
          <img
            v-if="$store.state.sceneClassName !== 'app'"
            :src="require('@/assets/images/about_logo.png')"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="big-event-container pt96 pb96">
      <div v-if="swiperOptions" class="w1200">
        <div class="profile-title">品牌故事</div>
        <div class="profile-years">
          <div class="line"></div>
          <div class="years-list"></div>
        </div>
        <div class="app-swiper-box">
          <div class="progress-bar">
            <div
              class="bar-fill"
              :style="{
                width: (100 / bannerTit.length) * swiperActiveIndex + '%',
              }"
            ></div>
          </div>
          <div class="swiper-btn">
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
        <div class="swiper-mask">
          <div class="next-mask"></div>
          <div class="prev-mask"></div>
        </div>
        <swiper class="brand-story" :options="swiperOptions">
          <swiper-slide
            v-for="(item, index) in bannerTit"
            :key="`bs_${index}`"
            class="brand-story-item"
          >
            <div class="brand-story-item-title">{{ item }}年</div>
            <div class="brand-story-item-desc">
              <h6 class="T6 mb4">10月</h6>
              <p class="T6">
                知链获腾讯数亿元人民币C轮融资，同时升级为以知识产品与用户服务为核心的技术服务商
              </p>
            </div>
            <div class="brand-story-item-desc">
              <h6 class="T6 mb4">5月</h6>
              <p class="T6">
                知链客户量突破百万，客户开始扩展至零售、金融、医疗、建筑、出版、旅游和健身等多个领域
              </p>
            </div>
            <div class="brand-story-item-desc">
              <h6 class="T6 mb4">3月</h6>
              <p class="T6">
                响应停课不停学号召，全员在疫情期间全力保证产品服务不断档
              </p>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    
    <div class="w1200 profile-culture">
      <div class="profile-title">我们始终秉承的理念</div>
      <ul class="culture">
        <li class="culture-item">
          <img
            :src="require('@/assets/images/introduce7.png')"
            alt=""
            class="culture-item-img"
          />
          <h3 class="culture-item-title">专业技术</h3>
          <p class="culture-item-desc">
            我们拥有行业专业技术实力与资深工程开发团队，为您的商业变现及产品需求保驾护航。
          </p>
        </li>

        <li class="culture-item">
          <img
            :src="require('@/assets/images/introduce9.png')"
            alt=""
            class="culture-item-img"
          />
          <h3 class="culture-item-title">贴心服务</h3>
          <p class="culture-item-desc">
            我们始终坚持优质的服务理念，无论任何时候您遇到困难，我们都会及时提供精准有效的解决方案。
          </p>
        </li>

        <li class="culture-item">
          <img
            :src="require('@/assets/images/introduce10.png')"
            alt=""
            class="culture-item-img"
          />
          <h3 class="culture-item-title">创业伙伴</h3>
          <p class="culture-item-desc">
            我们把每一位客户都当做创业伙伴，期盼在未来成长的道路上一路相伴，携手前行。
          </p>
        </li>
      </ul>
    </div>
    <div class="profile-desc-box">
      <div class="profile-desc-wrapper w1200">
        <div class="profile-title">我们努力践行的文化</div>
        <div class="profile-list">
          <div class="profile-item">
            <img :src="require('@/assets/images/introduce4.png')" alt="" />
            <p>使命</p>
            <h6>让知识更有价值</h6>
          </div>
          <div class="profile-item">
            <img :src="require('@/assets/images/introduce5.png')" alt="" />
            <p>愿景</p>
            <h6>最值得信赖的技术服务商</h6>
          </div>
          <div class="profile-item">
            <img :src="require('@/assets/images/introduce6.png')" alt="" />
            <p>价值观</p>
            <h6>以客户为中心，向善，有担当</h6>
          </div>
        </div>
      </div>
    </div>
    <!--
    <div class="w1200 administrator-wrapper">
      <div class="profile-title">高管团队</div>
      <div class="administrator-list">
        <div v-for="item in 4" :key="`al_${item}`" class="administrator-item">
          <div class="administrator-img">
            <img :src="require('@/assets/images/introduce8.png')" alt="" />
            <h3>鲍春健 &nbsp; BagBao</h3>
            <p class="T7">创始人CEO</p>
          </div>
          <div class="administrator-desc">
            <ul class="honor-list">
              <li class="honor-item">10年大数据相关研究经验</li>
              <li class="honor-item">原腾讯数据平台部总监</li>
              <li class="honor-item">T4级专家，大数据行业专家</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    -->
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay, Navigation } from 'swiper';
import Free from '@/components/Free';
SwiperCore.use([Pagination, Autoplay, Navigation]);
const bannerTit = ['2020', '2019', '2018', '2017', '2016'];
export default {
  data() {
    return {
      isUpdate: false,
      bannerTit,
      swiperActiveIndex: 1,
      swiperOptions: null
    };
  },
  mounted() {
    const swiperOptions = {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      slidesPerView: 3,
      spaceBetween: 32,
      centeredSlides: true,
      pagination: {
        el: '.years-list',
        clickable: true,
        renderBullet: (index, className) => {
          return `<div class="profile-year ${className}" data-distance="${index}"><p>${bannerTit[index]}</p></div>`;
        }
      },
      on: {
        slideChangeTransitionStart: (swiper) => {
          this.swiperActiveIndex = swiper.activeIndex + 1;
        }
      }
    };
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iPad|Mobile)/i)) {
      swiperOptions.slidesPerView = 1;
      swiperOptions.centeredSlides = false;
    }
    this.swiperOptions = swiperOptions;
  },
  components: {
    'v-free': Free
  }
};
</script>

<style lang="scss">
.introduce-module {
  .profile-title {
    margin-bottom: 40px;
    font-size: 36px;
    text-align: center;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .profile-banner {
    height: 360px;
    padding-top: 160px;
    background: url('~@/assets/images/introduce1.png') center no-repeat;
    background-size: cover;
  }
  .profile-banner .profile-title {
    margin-bottom: 0;
    font-size: 64px;
    font-weight: 600;
  }
  .brief-content-text-wrapper {
    padding: 96px 0;
    background: url('~@/assets/images/introduce2.png') center no-repeat;
    background-size: cover;
  }
  .brief-content-text-wrapper .brief-content-box {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 1168px;
    height: 500px;
    -webkit-box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);
  }
  .brief-content-text-wrapper .brief-content-text {
    position: relative;
    padding: 133px 44px 133px 40px;
    border-radius: 8px 0 0 8px;
  }
  .brief-content-text-wrapper .brief-content-text .brief-content-text__title {
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
  }
  .brief-content-text-wrapper .brief-content-text img {
    position: absolute;
    bottom: -84px;
    left: 0;
    width: 304px;
    height: 304px;
  }
  .brief-content-text-wrapper img {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 456px;
    height: 100%;
    border-radius: 0 8px 8px 0;
  }
  .brief-content-text-wrapper .brief-content-text__desc {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 33px;
    text-align: justify;
  }
  .big-event-container {
    position: relative;
    margin: 0 auto;
    background: url('~@/assets/images/introduce3.png') no-repeat;
    background-size: cover;
    & > div {
      position: relative;
    }
  }
  .big-event-container .profile-years {
    position: relative;
    height: 60px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-bottom: 48px;
  }
  .big-event-container .profile-years .line {
    position: absolute;
    bottom: 0;
    width: 1168px;
    height: 2px;
    border-radius: 1px;
    background: #b3d1ff;
  }
  .big-event-container .profile-years .years-list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 28px;
    color: #b3d1ff;
    .swiper-pagination-bullet {
      background-color: transparent;
      height: auto;
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      font-size: 36px;
      color: #1472ff;
    }
  }
  .big-event-container .profile-years .years-list .profile-year {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 160px;
    cursor: pointer;
  }
  .big-event-container .profile-years .years-list .profile-year p {
    position: absolute;
    bottom: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .big-event-container .profile-years .years-list .profile-year::after {
    position: absolute;
    bottom: -3px;
    left: calc(50% - 4px);
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #b3d1ff;
  }
  .big-event-container .profile-years .years-list .profile-year #years {
    display: none;
  }
  .big-event-container
    .profile-years
    .years-list
    .swiper-pagination-bullet-active {
    font-size: 36px;
    color: #1472ff;
  }
  .big-event-container
    .profile-years
    .years-list
    .swiper-pagination-bullet-active::after {
    left: calc(50% - 8px);
    bottom: -7px;
    width: 16px;
    height: 16px;
    background-color: #1472ff;
  }
  .big-event-container
    .profile-years
    .years-list
    .swiper-pagination-bullet-active
    #years {
    display: block;
  }
  .big-event-container .brand-story {
    margin: 0 auto;
    width: 1032px;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    display: -webkit-box;
    display: -moz-box;
  }
  .big-event-container .brand-story .brand-story-item-title {
    position: relative;
    margin-bottom: 22px;
    font-size: 20px;
    font-weight: 600;
  }
  .big-event-container .brand-story .brand-story-item-title::after {
    position: absolute;
    bottom: -12px;
    left: 0;
    content: '';
    display: inline-block;
    width: 16px;
    height: 2px;
    background: #333;
    border-radius: 1px;
    border: 1px solid #333;
  }
  .big-event-container .brand-story .brand-story-item-desc {
    margin-bottom: 16px;
  }
  .big-event-container .swiper-btn {
    position: absolute;
    bottom: 39%;
    margin: 0 auto;
    width: 1185px;
    z-index: 2;
  }
  .big-event-container .swiper-btn .swiper-button-next,
  .big-event-container .swiper-btn .swiper-button-prev {
    position: absolute;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    bottom: -70px;
    cursor: pointer;
  }
  .big-event-container .swiper-btn .swiper-button-next::after,
  .big-event-container .swiper-btn .swiper-button-prev::after {
    content: '';
    position: absolute;
    top: 17px;
    left: 14px;
    width: 10px;
    height: 10px;
    border-top: 2px solid #333;
    border-right: 2px solid #333;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .big-event-container .swiper-btn .swiper-button-prev::after {
    left: 19px;
    -webkit-transform: rotate(-135deg);
    transform: rotate(-135deg);
  }
  .big-event-container .swiper-btn .swiper-button-next {
    right: 50px;
  }
  .big-event-container .swiper-mask .next-mask,
  .big-event-container .swiper-mask .prev-mask {
    position: absolute;
    bottom: 0px;
    z-index: 1;
    margin: 0 auto;
    width: 50px;
    height: 360px;
    background: #f5f9ff;
    box-shadow: 0 0 20px 20px #f5f9ff;
  }
  .big-event-container .swiper-mask .next-mask {
    left: 32px;
  }
  .big-event-container .swiper-mask .prev-mask {
    right: 32px;
  }
  .big-event-container .swiper-button-next,
  .big-event-container .swiper-button-prev {
    cursor: pointer;
    background: 0 0;
    margin-top: 0;
    z-index: 6;
  }
  .big-event-container .swiper-button-next .iconfont,
  .big-event-container .swiper-button-prev .iconfont {
    font-size: 40px;
    color: #999;
  }
  .big-event-container .swiper-button-next {
    right: 50px;
  }
  .big-event-container .swiper-button-prev {
    left: 50px;
  }
  .administrator-wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 96px 0;
  }
  .administrator-wrapper .profile-title {
    margin-bottom: 64px;
  }
  .administrator-wrapper .administrator-list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .administrator-wrapper .administrator-list .administrator-item {
    width: 208px;
    position: relative;
    margin-left: 32px;
    cursor: pointer;
  }
  .administrator-wrapper .administrator-list .administrator-item:first-child,
  .administrator-wrapper .administrator-list .administrator-item:nth-child(6) {
    margin-left: 0;
  }
  .administrator-wrapper
    .administrator-list
    .administrator-item:nth-child(n + 6) {
    margin-top: 48px;
  }
  .administrator-wrapper
    .administrator-list
    .administrator-item:hover
    .administrator-desc {
    display: block;
  }
  .administrator-wrapper .administrator-list .administrator-img {
    text-align: left;
  }
  .administrator-wrapper .administrator-list .administrator-img img {
    margin-bottom: 17px;
    width: 208px;
    height: 277px;
    border-radius: 8px;
  }
  .administrator-wrapper .administrator-list .administrator-img h3 {
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .administrator-wrapper .administrator-list .administrator-desc {
    position: absolute;
    top: 0;
    left: 0;
    display: none;
    padding: 16px;
    width: 208px;
    height: 277px;
    background: rgba(7, 33, 92, 0.8);
    border-radius: 8px;
    color: #fff;
    font-size: 14px;
  }
  .administrator-wrapper
    .administrator-list
    .administrator-desc
    .administrator-desc-name {
    line-height: 22px;
    font-weight: 600;
  }
  .administrator-wrapper .administrator-list .administrator-desc .honor-list {
    position: absolute;
    bottom: 16px;
  }
  .administrator-wrapper .administrator-list .administrator-desc li {
    padding-right: 16px;
    line-height: 22px;
  }
  .corporate-apply {
    padding-top: 100px;
  }
  .profile-culture,
  .profile-desc-wrapper {
    padding: 96px 0;
  }
  .profile-desc-box {
    background-color: #f3f7ff;
  }
  .profile-desc-wrapper .profile-list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .profile-desc-wrapper .profile-list .profile-item {
    width: 368px;
  }
  .profile-desc-wrapper .profile-list .profile-item img {
    margin-bottom: 24px;
    width: 100%;
    border-radius: 8px;
  }
  .profile-desc-wrapper .profile-list .profile-item p {
    margin-bottom: 8px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .profile-culture .culture .culture-item .culture-item-title,
  .profile-desc-wrapper .profile-list .profile-item h6 {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
  .flex-column-center {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .profile-culture .culture {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .profile-culture .culture .culture-item {
    width: 368px;
    height: 276px;
    background: #fff;
    -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 32px;
  }
  .profile-culture .culture .culture-item .culture-item-title {
    margin-bottom: 8px;
  }
  .profile-culture .culture .culture-item .culture-item-desc {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .profile-culture .culture .culture-item .culture-item-img {
    margin-bottom: 24px;
    width: 80px;
    height: 80px;
  }
}
.app .introduce-module {
  padding-top: 1.04rem;
  .profile-banner {
    height: 5.92rem;
    padding: 0;
    position: relative;
    background: url('~@/assets/images/introduce1_app.png') top no-repeat;
    background-size: 100%;
    .profile-title {
      padding: 1.98rem 0 0.38rem;
      color: #fff;
      font-size: 0.8rem;
      font-weight: 600;
    }
  }
  .brief-content-text-wrapper {
    padding: 1.28rem 0.32rem;
    text-align: left;
    background: none;
    .brief-content-box {
      display: block;
      width: 100%;
      height: auto;
      box-shadow: none;
      .brief-content-text {
        padding: 0;
        .brief-content-text__title {
          margin: 0 0 0.48rem;
          font-size: 0.56rem;
          font-weight: 600;
        }
        .brief-content-text__desc {
          margin-bottom: 0.32rem;
          font-size: 0.28rem;
          line-height: 0.42rem;
          text-align: left;
        }
        img {
          display: none;
        }
      }
    }
  }
  .administrator-wrapper {
    display: block;
    padding: 1.28rem 0;
    .profile-title {
      padding-left: 0.32rem;
      padding-bottom: 0.48rem;
      text-align: left;
      font-size: 0.56rem;
      margin: 0;
    }
    .administrator-list {
      padding: 0 0.32rem;
      justify-content: space-around;
      .administrator-item {
        width: 3rem;
        margin: 0 0 0.32rem;
        .administrator-img {
          img {
            width: 100%;
            height: auto;
          }
        }
        h3 {
          font-size: 0.3rem;
          line-height: 0.5rem;
        }
        p {
          font-size: 0.25rem;
          color: #666;
        }
        .administrator-desc {
          margin-top: 0.24rem;
          position: static;
          display: block;
          background: transparent;
          width: auto;
          height: auto;
          padding: 0;
          .honor-list {
            position: static;
            .honor-item {
              padding: 0;
              line-height: 1.5;
              font-size: 0.22rem;
              color: #666;
            }
          }
        }
      }
    }
  }
  .profile-desc-wrapper,
  .profile-culture {
    padding: 1.28rem 0;
    .profile-title {
      padding-left: 0.32rem;
      margin-bottom: 0.48rem;
      text-align: left;
      font-size: 0.56rem;
    }
    .profile-list {
      display: block;
      .profile-item {
        width: auto;
        text-align: left;
        padding: 0 0.5rem;
        margin: 0 0 0.5rem;
        img {
          margin-bottom: 0;
        }
        p {
          font-size: 0.32rem;
          margin-top: 0.24rem;
          margin-bottom: 0.08rem;
          font-weight: 400;
        }
        h6 {
          font-size: 0.4rem;
          line-height: 0.66rem;
        }
      }
    }
  }
  .profile-culture {
    .culture {
      display: block;
      padding: 0 0.32rem;
      .culture-item {
        width: auto;
        height: auto;
        padding: 0.48rem 0.4rem;
        margin-bottom: 0.32rem;
        background: #fff;
        border-radius: 0.16rem;
        border: 0.02rem solid #eee;
        box-shadow: none;
        text-align: center;
        img {
          width: 1.6rem;
          height: auto;
          margin-bottom: 0.24rem;
        }
        .culture-item-title {
          font-size: 0.4rem;
          font-weight: 500;
          margin-bottom: 0.16rem;
        }
        .culture-item-desc {
          font-size: 0.32rem;
          line-height: 0.48rem;
        }
      }
    }
  }
  .big-event-container {
    padding: 1.28rem 0;
    .profile-title {
      padding-left: 0.32rem;
      margin-bottom: 0.48rem;
      text-align: left;
      font-size: 0.56rem;
      font-weight: 600;
    }
    .profile-years {
      padding: 0 0.32rem;
      margin-bottom: 48px;
      height: 0.7rem;
      .line {
        width: 6.86rem;
        height: 0.04rem;
        border-radius: 0.02rem;
      }
      .years-list {
        width: 100%;
        font-size: 0.36rem;
        .swiper-pagination-bullet-active {
          font-size: inherit;
          &::after {
            width: 0.16rem;
            height: 0.16rem;
            bottom: -0.08rem;
          }
        }
        .profile-year {
          outline: none !important;
          width: 20%;
        }
      }
    }
    .app-swiper-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0.32rem 0.16rem;
      .progress-bar {
        position: relative;
        width: 4.8rem;
        height: 0.04rem;
        background: #c2daff;
        border-radius: 0.02rem;
        .bar-fill {
          position: absolute;
          top: 0;
          left: 0;
          height: 0.04rem;
          background: #1472ff;
          border-radius: 0.02rem;
          transition: all 0.3s;
        }
      }
    }
    .swiper-btn {
      position: static;
      display: flex;
      flex-direction: row-reverse;
      flex-shrink: 0;
      width: auto;
      margin: 0;
      .swiper-button-next,
      .swiper-button-prev {
        position: static;
        &::after {
          position: static;
        }
      }
    }
    .swiper-mask {
      display: none;
    }
    .brand-story {
      width: 100%;
      padding: 0 0.32rem;
      box-sizing: border-box;
      .brand-story-item-title {
        margin-bottom: 0.44rem;
        font-size: 0.32rem;
        line-height: 0.44rem;
        &::after {
          width: 0.32rem;
          height: 0.04rem;
          border-radius: 0.02rem;
          border: 0.02rem solid #333;
        }
      }
      .brand-story-item-desc {
        h6 {
          margin-bottom: 0.08rem;
          font-size: 0.28rem;
          font-weight: 500;
          line-height: 0.4rem;
        }
        p {
          font-size: 0.24rem;
          line-height: 0.36rem;
        }
      }
    }
    // .brand-story-item {
    // }
  }
}
</style>
